import { createFileRoute } from "@tanstack/react-router";
import { TestimonialPage } from "@/features/testimonial/TestimonialPage";

/** Public testimonial page for one request link. Sits outside the _app layout, so there is no app shell. */
export const Route = createFileRoute("/p/testimonial/$token")({
  component: TestimonialRoute,
});

function TestimonialRoute() {
  const { token } = Route.useParams();
  return <TestimonialPage token={token} />;
}
